import { Component, Input } from '@angular/core';
import { Lightbox } from 'ngx-lightbox';
import AssetHelper from 'src/app/helpers/asset-helper';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import Asset from 'src/app/model/asset';

@Component({
  selector: 'immo-ip-placer-project-completion-pictures',
  templateUrl: './immo-ip-placer-project-completion-pictures.component.html',
  styleUrls: ['./immo-ip-placer-project-completion-pictures.component.scss']
})
export class ImmoIPPlacerProjectCompletionPicturesComponent {
  @Input()
  executionPictures: Asset[];

  constructor(private _lightbox: Lightbox) {}

  openLightbox(index: number): void {
    if (!CollectionHelper.isPopulated(this.executionPictures)) {
      return;
    }
    const album = AssetHelper.getIAlbums(this.executionPictures);
    if (CollectionHelper.isPopulated(album)) {
      this._lightbox.open(album, index);
    }
  }
}
